export class LogRequest {
    sourceContext: string;
    memberName: string;
    message:string;
    errorCode: string;
    isWarning: boolean;
};
